import { Sparkle } from "lucide-react";

const ITEMS = [
  "Cosmic Blue Razz", "Unlimited Cones", "Jolly Rainbow", "Live Event Spinning", "Spicy Tamarindo",
  "Zkittlez", "16 Deep-Space Flavors", "Cosmic Birthday Cake", "Bulk Premium Tubs",
];

export const Marquee = () => (
  <div data-testid="flavor-marquee" className="relative overflow-hidden border-y border-white/10 bg-cosmic-elevated/60 py-5">
    <div className="animate-marquee-drift flex w-max items-center gap-10 whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-display text-lg sm:text-xl font-bold uppercase tracking-wide text-slate-200">{item}</span>
          <Sparkle size={16} className="text-cosmic-pink shrink-0" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
